<template>
  <div class="offstage-wrapper">
    <!-- <div class="tour-bckgnd grid-100 grid-parent"></div> -->
   <h1 class="main-title individual grid-container">Off Stage</h1>
   <div class="mobile-navigation off-stage layer3"></div>
   <div class="offstage-list layer2">
    <div class="grid-container grid-100" v-for="item in items" :key="item.id">
      <div class="grid-100 grid-parent">
        <div class="video-item grid-100 grid-parent">
          <div class="video-header grid-100 grid-parent">
            <div class="video">
              <iframe id="main-video" :src="item.video_id_url" width="640" height="352" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
          </div>
          <!-- <h4>Off Stage video - 2.</h4> -->
          <!-- <div class="rent-cta white"><span class="price">£0.00</span></div> -->
          <!-- <div class="buy-cta white"><span class="price">£3.00</span></div> -->
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { apiRequest } from "../services";

export default {
  name: 'test',
  originalData: [
    {
      video_id_url: "https://player.vimeo.com/video/233687092",
    },
  ],
  data () {
    return {
      items: []
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    apiRequest("off-stage")
        .then(this.init.bind(this))
        .catch(this.failed);
    if (this.$route.params.autoplay) {
      setTimeout(function () {
        window.scrollTo(0, document.getElementById('main-video').getBoundingClientRect().top)
        document.getElementById('main-video').src += '?autoplay=1'
      }, 100)
    }
  },
  methods: {
      init(data) {
        if (!data || data && data.length === 0) {
          this.items = this.$options.originalData;
        } else {
          this.items = data;
        }
      },
      failed(error) {
        console.warn(error);
      },
    },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// OffStage.vue?79f6f01c